import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const GWIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="GW" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#FBCD17"
        fillRule="evenodd"
        d="M8 0h8v6H8V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#0B9E7A"
        fillRule="evenodd"
        d="M8 6h8v6H8V6Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E11C1B"
        fillRule="evenodd"
        d="M0 0h8v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#1D1D1D"
        fillRule="evenodd"
        d="M4.465 7.303 2.723 8.512l.556-2.07L2 5.119l1.732-.072L4.465 3l.733 2.047h1.73L5.65 6.442l.64 1.948-1.826-1.087Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
